const fHomeHeroAnimation = () => {

    if (typeof TweenMax !== 'undefined') {
        const oHero = document.querySelector('.js-hero');
        const titles = oHero.querySelector('.section-hero__title');
        const button = oHero.querySelector('.section-hero__content .button');
        const image = oHero.querySelector('.section-hero__image img') || oHero.querySelector('.section-hero__video');
        const blocks = oHero.querySelectorAll('.section-hero__block');
        const contentImage = oHero.querySelector('.section-hero__content__image');
        const hhBackground = oHero.querySelector('.section-hero__content__col__background');
        const isVideo = image.nodeName === "VIDEO";

        const timeline = new TimelineMax();

        timeline
            .set(titles,
                {
                    y: '10px',
                    autoAlpha: 0,
                });

        if (button) {
            timeline.set(button,
                {
                    autoAlpha: 0,
                });
        }

        timeline.set(blocks,
                {
                    autoAlpha: 0,
                    y: '10px',
                })
            .to(hhBackground,
                1,
                {
                    ease: Quart.easeOut,
                    scaleX: 1,
                    scaleY: 1,
                    opacity: 0.9
                } /*, '-=2'*/)
            .to(titles,
                2.1,
                {
                    ease: Quart.easeOut,
                    autoAlpha: 1,
                    y: '0px',
                } /*, '-=2.2'*/);

        if (button) {
            timeline.to(button,
                2.1,
                {
                    autoAlpha: 1,
                },
                '-=3.0')
        }

        timeline.to(blocks,
            1,
            {
                autoAlpha: 1,
                y: '0px',
            },
            '-=3.0')
        /*
    .set(image, {
      autoAlpha: 0,
      })
    .to(image, 3, {
      ease: Quart.easeOut,
      scale: isVideo ? 1 : 1.05,
    }, '-=.1.2')
    .to(image, 3, {
      autoAlpha: 1,
    }, '-=3')
    */
        if (contentImage) {
            timeline.to(contentImage,
                1,
                {
                    autoAlpha: 1
                },
                '-=1.8')
        }


    }
};
